import styled from 'styled-components';

import { body } from '@constants/fonts';

export const FilterDiv = styled.div<{ hasFilters: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-width: 100px;
  height: 30px;
  border-radius: 29px;
  background-color: ${(props) =>
    props.hasFilters
      ? props.theme.palette.primary.main
      : props.theme.palette.background.paper};
  color: ${(props) =>
    props.hasFilters
      ? props.theme.palette.primary.contrastText
      : props.theme.palette.text.primary};
  font-size: 15px;
  position: relative;
  cursor: pointer;
  border: 0;
  box-shadow: ${({ theme }) => theme.shadows[1]};
`;

export const NumFilterApplied = styled.div`
  width: 15px;
  height: 15px;
  font-size: 11px;
  font-weight: bold;
  background-color: ${({ theme }) => theme.palette.secondary.main};
  border-radius: 50%;
  color: ${({ theme }) => theme.palette.secondary.contrastText};
  position: absolute;
  right: 12px;
  bottom: 18px;
  text-align: center;
`;

export const LabelFormat = styled.p<{ hasFilters: boolean }>`
  font-size: 14px;
  font-weight: 500;
  font-family: ${body};
  letter-spacing: 0.3pt;
  text-transform: uppercase;
  color: ${(props) =>
    props.hasFilters
      ? props.theme.palette.primary.contrastText
      : props.theme.palette.text.primary};
`;
